export default "__VITE_ASSET__DN$liVHn__"